var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0466 18.6791C5.06539 18.6791 1.02734 14.641 1.02734 9.65986C1.02734 4.67867 5.06539 0.640625 10.0466 0.640625C15.0278 0.640625 19.0658 4.67867 19.0658 9.65986C19.0658 14.641 15.0278 18.6791 10.0466 18.6791ZM10.0466 18.6791V8.37139C10.0466 6.9482 11.2003 5.79447 12.6235 5.79447H13.2677M6.82542 10.9483H13.2677",
    stroke: "#2F2F2F",
    strokeWidth: 1.28846
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c2da38c57656b08a53156fb0016fd18d.svg";
export { ForwardRef as ReactComponent };